// extracted by mini-css-extract-plugin
module.exports = {"alert":"z3Q1gAis"};